/* eslint-disable no-tabs */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import StyledGoogleButton, { GLogo } from './styles';

export interface ITokenResaponse {
  /** The access token of a successful token response. */
  access_token: string;
  /** The lifetime in seconds of the access token. */
  expires_in: number;
  /** The hosted domain the signed-in user belongs to. */
  hd?: string;
  /** The prompt value that was used from the possible list of values specified by TokenClientConfig or OverridableTokenClientConfig */
  prompt: string;
  /** The type of the token issued. */
  token_type: string;
  /** A space-delimited list of scopes that are approved by the user. */
  scope: string;
  /** The string value that your application uses to maintain state between your authorization request and the response. */
  state?: string;
  /** A single ASCII error code. */
  // error?: ErrorCode;
  /**	Human-readable ASCII text providing additional information, used to assist the client developer in understanding the error that occurred. */
  error_description?: string;
  /** A URI identifying a human-readable web page with information about the error, used to provide the client developer with additional information about the error. */
  error_uri?: string;
}

interface ButtonGoogleLoginProps {
  text?: string;
  onSuccess?: Function;
  onError?: Function;
}

const ButtonGoogleLogin: React.FC<ButtonGoogleLoginProps> = ({
  text,
  onSuccess,
  onError,
}) => {
  const handleOnClickLogin = useGoogleLogin({
    onSuccess: (tokenResponse: ITokenResaponse) => {
      onSuccess?.(tokenResponse);
    },
    onError: (errorResponse) => {
      onError?.(errorResponse);
    },
  });

  return (
    <>
      <StyledGoogleButton
        altVersion
        onClick={() => {
          return handleOnClickLogin();
        }}
      >
        <GLogo altVersion />
        <span>{text}</span>
      </StyledGoogleButton>
    </>
  );
};

export default ButtonGoogleLogin;
